module.exports = __webpack_public_path__ + "assets/images/coin-$1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-$1.png
// module id = 1499
// module chunks = 1